// extracted by mini-css-extract-plugin
export var darkIcon = "toggle-styles-module--dark-icon--1947e";
export var lightIcon = "toggle-styles-module--light-icon--02a01";
export var switchWrap = "toggle-styles-module--switch-wrap--61a1d";